// extracted by mini-css-extract-plugin
module.exports = {"body":"ClientData_body__2esbd","infoContainer":"ClientData_infoContainer__3arV8","icon":"ClientData_icon__H1HUy"};